const UNAUTHENTICATED_ERR_CODE = 16;

/** @ngInject */
export default function AuthInterceptor($httpProvider) {
    /** @ngInject */
    $httpProvider.interceptors.push((AuthService, $q) => {
        function request(config) {
            const accessToken = AuthService.getAccessToken();

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }

            return config;
        }

        function responseError(rejection) {
            const { data: { Code } } = rejection;
            if (Code === UNAUTHENTICATED_ERR_CODE) {
                return AuthService.login();
            }
            return $q.reject(rejection);
        }

        return {
            request,
            responseError
        };
    });
}



// WEBPACK FOOTER //
// ./app/services/auth/auth.interceptor.js